import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { IChangeBase } from './change_base';

export abstract class StreamBase<T, P> {
  public changes: BehaviorSubject<IChangeBase<T, P>>;

  public constructor(changes: BehaviorSubject<IChangeBase<T, P>>) {
    this.changes = changes;
  }

  abstract guard(): (change: IChangeBase<T, P>) => boolean;

  public get stream(): Observable<IChangeBase<T, P>> {
    return this.changes.pipe(
      distinctUntilChanged(
        (prev: IChangeBase<T, P>, current: IChangeBase<T, P>): boolean =>
          prev.type === current.type && prev.payload === current.payload
      ),
      filter(this.guard())
    );
  }
}
